import ClaudeLogoIcon from "@/assets/icons/claudelogo.svg?react";
import { cn } from "@/lib/utils";

/** Claude's mark (Simple Icons, CC0), in Claude's own orange unless a colour is passed. */
export default function ClaudeLogo({ className }: { className?: string }) {
  return <ClaudeLogoIcon className={cn("shrink-0 text-[#D97757]", className)} aria-hidden />;
}
